export const SITE_URL = 'https://typeclicktests.com';
export const SITE_NAME = 'Type Click Tests';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/favicon.svg`;

export const buildCanonicalUrl = (path = '/') => {
  if (!path || path === '/') return `${SITE_URL}/`;
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${clean.endsWith('/') ? clean : `${clean}/`}`;
};
